import { client } from './../client'

const getContacts = async () => {
  try {
    let response = await client.get('/v1/user/contacts')
    return response.data
  } catch (error) {
    throw error
  }
}

const postContact = async (contact) => {
  try {
    let response = await client.post('/v1/user/contacts', contact)
    return response.data
  } catch (error) {
    throw error
  }
}

const postConnection = async (contactId) => {
  try {
    let response = await client.post(`/v1/user/contacts/connection/${contactId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const deleteConnection = async (connectionId) => {
  try {
    let response = await client.delete(`/v1/user/contacts/connection/${connectionId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const deleteNumber = async (phoneNumberId) => {
  try {
    let response = await client.delete(`/v1/user/contacts/number/${phoneNumberId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const putContact = async (data) => {
  try {
    console.log(data)
    let response = await client.put(`/v1/user/contacts/${data.contactId}`, data.contactData)
    return response.data
  } catch (error) {
    throw error
  }
}

const deleteContact = async (contactId) => {
  try {
    let response = await client.delete(`/v1/user/contacts/${contactId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const getSpillover = async () => {
  try {
    let response = await client.get(`/v1/user/contacts/spillover`)
    return response.data
  } catch (error) {
    throw error
  }
}

const postSpillover = async (didGroupId) => {
  try {
    let response = await client.post(`/v1/user/contacts/spillover/${didGroupId}`, { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  getContacts,
  postContact,
  postConnection,
  deleteConnection,
  putContact,
  deleteNumber,
  deleteContact,
  getSpillover,
  postSpillover
}



// WEBPACK FOOTER //
// ./src/api/user/contacts/index.js